import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { CustomerType } from '../types/customer-type';
import { Hub } from '../types/hub';
import { HubInformation } from '../types/hub-information';
import { InstallationState } from '../types/installation-state';
import { Installer } from '../types/installer';
import { Shipment } from '../types/shipment';
import { StockLocation } from '../types/stock-location';
import { StockOfficeStatus } from '../types/stock-office-status';
import { StockStatus } from '../types/stock-status';


@Component({
  selector: 'mod-stock',
  templateUrl: './modify-stock.component.html',
  styleUrls: ['./modify-stock.component.css'],
  providers: [HubService],
})

export class ModStockComponent implements OnInit, OnChanges {
  @Input() inSerialList: number[];
  @Output() mod_made = new EventEmitter<boolean>();
  errorMessage: string;
  hubIdsArray: number[];
  public successFailFlag: boolean;
  public successFailStock = 'This change has failed to be Applied :-(\nGo Ask Will why';
  errorMessages = <string[]>[];
  public hubIds: string;
  editable = false;

  hubInformation = {} as HubInformation;
  customer_types = [] as CustomerType[];
  installation_states = [] as InstallationState[];
  stock_statuses = [] as StockStatus[];
  stock_locations = [] as StockLocation[];
  seai_groups: number[] = [0, 1, 2, 3, 4, 5];
  installer_list = [] as Installer[];
  shipment_list = [] as Shipment[];
  stockOfficeStatus = <StockOfficeStatus[]>[];

  constructor(
    private hubService: HubService,
  ) {
  }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    this.successFailFlag = false;
    try {
      this.hubService.getLookupTable('customer_types').subscribe(
        lookup_values => this.customer_types = <CustomerType[]>lookup_values,
        error => this.errorMessage = <any>error,
      );
      this.hubService.getLookupTable('installation_states').subscribe(
        lookup_values => this.installation_states = <InstallationState[]>lookup_values,
        error => this.errorMessage = <any>error,
      );
      this.hubService.getLookupTable('stock_statuses').subscribe(
        lookup_values => this.stock_statuses = <StockStatus[]>lookup_values,
        error => this.errorMessage = <any>error,
      );
      this.hubService.getLookupTable('stock_locations').subscribe(
        lookup_values => this.stock_locations = <StockLocation[]>lookup_values,
        error => this.errorMessage = <any>error,
      );
      this.hubService.getLookupTable('installers').subscribe(
        lookup_values => this.installer_list = <Installer[]>lookup_values,
        error => this.errorMessages = <any>error,
      );
      this.hubService.getLookupTable('shipment').subscribe(
        lookup_values => this.shipment_list = <Shipment[]>lookup_values,
        error => this.errorMessages = <any>error,
      );
      this.hubService.getLookupTable('stock_office_status').subscribe(
        lookup_values => this.stockOfficeStatus = <StockOfficeStatus[]>lookup_values,
        error => this.errorMessage = <any>error,
      );
    } catch (e) {
      console.log('Meh: ' + e);
    }

  }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      // console.log('Property ' + propName + ' changed');
      /*   switch (propName) {
           case 'inHub':
             //this.switchHub();
             break;
         }*/
    }
  }

  isValid(): boolean {
    let errors = <string[]>[];
    const early_install_date = Date.parse('2014-01-01');

    if (this.hubInformation.installation_state_id >= 4 && this.hubInformation.installation_state_id <= 6) {
      if (!this.hubInformation.installed || Date.parse(this.hubInformation.installed) < early_install_date) {
        errors.push(`The installation date should be set (estimate, if not known)`);
      }
    } else if (this.hubInformation.installed) {
      if (Date.parse(this.hubInformation.installed) < early_install_date) {
        errors.push(`The installation date should be real, or empty.`);
      }
    }

    if (this.hubInformation.dispatched) {
      if (Date.parse(this.hubInformation.dispatched) < early_install_date) {
        errors.push(`The dispatched date should be real, or empty.`);
      }
    }

    if (errors) {
      this.errorMessages = errors;
    } else {
      this.errorMessages = <string[]>[];
    }
    return (errors.length === 0);
  }

  cancel() {
    this.hubIds = null;
    this.hubInformation = <HubInformation>{};
    this.mod_made.emit(false);
    this.successFailFlag = false;
    this.hubIdsArray = [];

    for(let i = 0; i < this.stockOfficeStatus.length; i++){
      console.log(this.stockOfficeStatus[i].stock_office_status_details);
      console.log(this.stockOfficeStatus[i].stock_office_status_id);
    }
  }

  fill() {
    let _this = this;
    _this.hubIds = '';
    this.inSerialList.forEach(function (value) {
      value = Hub.HubIDToSerial(value);
      _this.hubIds = _this.hubIds.concat(value.toString(), '\n');
    });
  }

  /*
  *This function parses the hubIds or serialIds that a user has input on the modify stock page.
  *They are read in as a string and then parsed here.
  *A semicolon, a comma, a space or newline can be used to separate multiple Ids
  *
  */
  parseHubIds(): void {
    if (this.hubIds.includes(';')) {
      this.hubIdsArray = this.hubIds.split(';').map(temp => Hub.SerialToHubID(+temp));
    } else if (this.hubIds.includes(',')) {
      this.hubIdsArray = this.hubIds.split(',').map(temp => Hub.SerialToHubID(+temp));
    } else if (this.hubIds.includes(' ')) {
      this.hubIdsArray = this.hubIds.split(' ').map(temp => Hub.SerialToHubID(+temp));
    } else if (this.hubIds.includes('\n')) {
      this.hubIdsArray = this.hubIds.split('\n').map(temp => Hub.SerialToHubID(+temp));
    } else {
      this.hubIdsArray = [];
      this.hubIdsArray.push(Hub.SerialToHubID(+this.hubIds));
    }
  }

  save(): void {

    this.parseHubIds();

    if (!this.hubInformation.installation_state_id || this.hubInformation.installation_state_id < 1) {
      this.hubInformation.installation_state_id = undefined;
    }
    if (!this.hubInformation.stock_location_id || this.hubInformation.stock_location_id < 1) {
      this.hubInformation.stock_location_id = undefined;
    }
    if (!this.hubInformation.stock_status_id || this.hubInformation.stock_status_id < 1) {
      this.hubInformation.stock_status_id = undefined;
    }
    if (!this.hubInformation.customer_type_id || this.hubInformation.customer_type_id < 1) {
      this.hubInformation.customer_type_id = undefined;
    }
    if (!this.hubInformation.seai_trial_group || this.hubInformation.seai_trial_group < 0 || this.hubInformation.seai_trial_group > 6) {
      this.hubInformation.seai_trial_group = undefined;
    }
    if (this.hubInformation.installed === '') {
      this.hubInformation.installed = undefined;
    }
    if (this.hubInformation.dispatched === '') {
      this.hubInformation.dispatched = undefined;
    }

    if (!this.hubInformation.installer_id || this.hubInformation.installer_id < 1) {
      this.hubInformation.installer_id = undefined;
    }else{
      this.hubInformation.installer_id = +this.hubInformation.installer_id
    }

    if (!this.hubInformation.stock_docket_number || this.hubInformation.stock_docket_number < 1) {
      this.hubInformation.stock_docket_number = undefined;
    }else{
      this.hubInformation.stock_docket_number = +this.hubInformation.stock_docket_number;
    }

    if (! this.hubInformation.carton_number ||  this.hubInformation.carton_number < 1) {
      this.hubInformation.carton_number = undefined;
    }else{
      this.hubInformation.carton_number = +this.hubInformation.carton_number;
    }

    this.hubService.writeStockInformation(this.hubIdsArray, this.hubInformation)
      .subscribe((data) => {
        this.editable = false;
        this.mod_made.emit(true);
        if (data.status === 'success') { this.cancel(); } else { this.successFailFlag = true; }
      });
  }

}
